import React, { useState } from 'react';
import './OnboardingDialog.css';

const STEPS = [
  {
    title: 'Welcome to Tweedia Studio!',
    content: (
      <>
        <p>Tweedia Studio helps you create professional timelapse videos with intelligent motion analysis.</p>
        <p>Upload your photo sequences or raw footage, and Tweedia automatically identifies the best moments and compiles them into a polished edit.</p>
      </>
    ),
    nextLabel: 'Get Started',
  },
  {
    title: 'How Credits Work',
    content: (
      <>
        <p>Credits are used to generate edited videos. Each credit covers approximately 1 minute of 1080p video processing.</p>
        <div className="onboarding-credits-info">
          <div className="onboarding-credit-badge">10 free credits</div>
          <p>You have 10 free credits to get started!</p>
        </div>
        <div className="onboarding-resolution-info">
          <p><strong>Resolution pricing:</strong></p>
          <ul>
            <li>720p — 0.5 credits per minute</li>
            <li>1080p — 1 credit per minute</li>
            <li>4K — 3.5 credits per minute</li>
          </ul>
          <p className="onboarding-rounding-note">Partial minutes are rounded up to the nearest whole credit, with a minimum of 1 credit per video.</p>
        </div>
      </>
    ),
    nextLabel: 'Next',
  },
  {
    title: 'Create Your First Video',
    content: (
      <>
        <div className="onboarding-steps">
          <div className="onboarding-step">
            <span className="onboarding-step-number">1</span>
            <span>Create a new project</span>
          </div>
          <div className="onboarding-step">
            <span className="onboarding-step-number">2</span>
            <span>Upload your timelapse video</span>
          </div>
          <div className="onboarding-step">
            <span className="onboarding-step-number">3</span>
            <span>Review motion analysis and adjust settings</span>
          </div>
          <div className="onboarding-step">
            <span className="onboarding-step-number">4</span>
            <span>Generate your edited video</span>
          </div>
        </div>
      </>
    ),
    nextLabel: "Let's Go!",
  },
];

const OnboardingDialog = ({ onComplete }) => {
  const [step, setStep] = useState(0);

  const handleNext = () => {
    if (step < STEPS.length - 1) {
      setStep(step + 1);
    } else {
      onComplete();
    }
  };

  const currentStep = STEPS[step];

  return (
    <div className="dialog-overlay">
      <div className="onboarding-dialog" role="dialog" aria-modal="true" aria-labelledby="onboarding-title">
        <div className="onboarding-progress">
          {STEPS.map((_, i) => (
            <div key={i} className={`onboarding-dot ${i === step ? 'active' : ''} ${i < step ? 'completed' : ''}`} />
          ))}
        </div>
        <h2 id="onboarding-title">{currentStep.title}</h2>
        <div className="onboarding-content">
          {currentStep.content}
        </div>
        <div className="onboarding-actions">
          <button className="btn-skip" onClick={onComplete}>Skip</button>
          <button className="btn btn-teal" onClick={handleNext}>{currentStep.nextLabel}</button>
        </div>
      </div>
    </div>
  );
};

export default OnboardingDialog;
